<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none"></div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block">
            <div class="main-container-first" :style="bgStyle">
                <div class="first-block">
                    <img src="@/assets/img/jameson-logo-age-confirm.png" alt="" class="jameson-logo-age-confirm">
                    <div class="main-content-container">
                        <div class="block-one">
                            <h1 class="big-title">название на мероприятие</h1>
                            <p class="title-top">присоединяйся к мероприятию от jameson</p>
                        </div>
                        <div>
                            <img src="@/assets/img/j.png" class="j-img" alt="">
                        </div>
                    </div>
                </div>
                <img class="first-wave" src="@/assets/img/wave.png" alt="">
            </div>
            <div class="main-container-second">
                <div>
                    <h4 class="h4-title">дата,место и время проведения мероприятия</h4>
                    <div class="box-content-container">
                        <div class="box-container">
                            <div class="outer-box">
                                <div class="info-box">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M21.8739 23.9772V11.1187C21.8739 8.74234 25.5968 8.34629 26.0193 10.8546C26.1777 11.7788 25.9401 20.8616 26.0457 22.7098C26.0721 23.3171 26.4681 23.4491 27.2603 24.2677L30.9304 27.9378C31.6961 28.7035 32.3826 29.0731 32.3826 30.3405C32.3826 31.3966 31.4848 32.3208 30.2175 32.3208C29.1349 32.3208 28.3692 31.2118 27.7619 30.6045L23.6166 26.4592C23.0093 25.8519 21.8739 25.0598 21.8739 23.9772ZM0.698242 23.5812C0.698242 28.4922 2.09763 33.3241 4.89641 37.2054C5.82054 38.4728 6.16379 38.7632 6.85028 39.6081C7.37835 40.2682 8.01204 40.7963 8.64572 41.3772C10.2035 42.8294 12.4742 44.1232 14.3753 45.0737C19.9465 47.8197 28.0788 47.8461 33.6499 45.0473C36.6071 43.5687 36.7127 43.4103 38.9306 41.7204C39.2475 41.4828 39.4059 41.2452 39.6964 41.0075C40.0396 40.7435 40.1716 40.6115 40.4885 40.2946C42.4423 38.3408 43.9473 35.9644 45.1619 33.4825C46.5085 30.7629 47.2478 26.9608 47.2478 23.766C47.2478 18.6437 45.1619 12.7293 41.8878 9.03278L40.4885 7.44857L37.3464 4.83461C31.7225 0.926878 25.5176 -0.182073 18.7319 1.21732C17.4645 1.48135 15.5371 2.14144 14.4281 2.66952C12.0782 3.80487 11.0485 4.46496 9.12099 5.99637C8.77774 6.2604 8.64572 6.41883 8.32888 6.70927C6.95589 7.92383 6.71826 8.26708 5.5565 9.66647C2.70492 13.1253 0.698242 18.7493 0.698242 23.5812Z"
                                            fill="#007749" />
                                    </svg>
                                    <span class="text">НАЧАЛО В 19:00</span>
                                </div>
                            </div>

                            <div class="outer-box">
                                <div class="info-box">
                                    <svg width="47" height="44" viewBox="0 0 47 44" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M36.4371 37.489H33.1152C32.4812 37.489 31.8726 37.1593 31.8726 36.5507V32.6456C31.8726 32.1638 32.3544 31.7073 32.8109 31.7073H36.6146C37.274 31.7073 37.6543 32.2652 37.6543 32.9499V36.2718C37.6797 37.0579 37.2486 37.489 36.4371 37.489ZM20.3853 36.2464V32.9245C20.3853 32.1638 20.7403 31.6819 21.5264 31.6819H25.2288C25.7106 31.6819 26.167 32.1638 26.167 32.6202V36.5254C26.167 37.1086 25.6345 37.4636 25.0259 37.4636H21.6025C20.8671 37.489 20.3853 36.9818 20.3853 36.2464ZM9.05014 36.2464V32.9245C9.05014 32.2398 9.43052 31.6819 10.0898 31.6819H13.8936C14.3754 31.6819 14.8318 32.1638 14.8318 32.6202V36.3225C14.8318 37.0072 14.2232 37.4636 13.5132 37.4636H10.1913C9.6841 37.489 9.05014 37.0579 9.05014 36.2464ZM36.7414 24.5563H32.8363C32.3544 24.5563 31.898 24.0744 31.898 23.618V19.7128C31.898 19.1803 32.4559 18.7746 32.9377 18.7746H36.4625C37.1979 18.7746 37.705 19.2564 37.705 20.0171V23.2376C37.6797 23.9477 37.4261 24.5563 36.7414 24.5563ZM20.3853 23.3137V19.9918C20.3853 19.2564 20.8671 18.7492 21.6279 18.7492H24.9498C25.6345 18.7492 26.1924 19.1296 26.1924 19.7889V23.4912C26.1924 24.2012 25.8627 24.5309 25.1527 24.5309H21.4504C20.7657 24.5563 20.3853 23.9984 20.3853 23.3137ZM9.05014 23.3137V19.9918C9.05014 19.2564 9.53195 18.7492 10.2927 18.7492H13.6146C14.2486 18.7492 14.8572 19.0789 14.8572 19.6875V23.2883C14.8572 23.9477 14.4515 24.5309 13.8175 24.5309H10.1152C9.43052 24.5563 9.05014 23.9984 9.05014 23.3137ZM0.884766 39.9488C0.884766 42.0281 2.45698 43.93 4.48565 43.93H42.1428C44.2729 43.93 46.8848 42.1042 46.8848 39.467V13.424H0.884766V39.9488Z"
                                            fill="#007749" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M0.884766 4.95428V10.457H46.7073V5.05571C46.7073 2.95097 44.1714 0.973022 41.9653 0.973022H37.5022V5.43609C37.5022 7.05902 34.7381 7.03366 34.7381 5.43609V0.973022H11.7381V5.43609C11.7381 7.05902 8.97407 7.03366 8.97407 5.43609V0.973022H4.40957C2.45698 0.973022 0.884766 2.97633 0.884766 4.95428Z"
                                            fill="#007749" />
                                    </svg>
                                    <span class="text">25 МАЯ 2025 ГОДА</span>
                                </div>
                            </div>

                            <div class="outer-box">
                                <div class="info-box">
                                    <svg width="43" height="49" viewBox="0 0 43 49" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M14.3492 16.5524C14.246 16.002 14.6244 14.3165 14.8996 13.6629C15.5188 12.0805 16.7915 10.7734 18.2707 10.051C19.5434 9.43182 21.057 9.19103 22.6049 9.46622C24.7721 9.84461 26.664 11.3238 27.5928 13.2501C28.212 14.5229 28.4528 16.0364 28.1776 17.5844C28.0744 18.1692 27.9368 18.5132 27.7648 18.9603C27.1456 20.5427 25.8728 21.8499 24.3937 22.5722C22.6393 23.4322 20.5754 23.5354 18.6835 22.7786C16.5163 21.9187 14.7276 19.7859 14.4524 17.4124L14.3492 16.5524ZM20.7474 0.900879H21.7106C22.9145 0.935278 24.1529 1.10727 25.3225 1.41686C25.9416 1.55446 26.1824 1.69206 26.7328 1.89845C27.2832 2.10484 27.524 2.17364 27.9712 2.41443C28.7968 2.82722 29.5191 3.20561 30.2759 3.75599C32.6494 5.54474 33.9222 7.0583 35.2982 9.74142C36.4333 12.0117 36.7429 14.2133 36.7429 16.7588C36.7429 21.2651 34.4726 24.533 32.0991 28.0417L30.0695 31.2064C29.8631 31.5504 29.7255 31.7224 29.5191 32.0664C29.3127 32.3759 29.2095 32.5823 29.0032 32.8575L27.4896 35.2311C27.2832 35.5062 27.1456 35.747 26.9736 36.0222L23.8777 40.8381C22.9833 42.2485 21.573 45.31 19.853 42.386L8.57016 24.7738C7.33179 22.9506 5.99023 19.8891 5.99023 16.8964V15.486C5.99023 14.3853 6.26543 13.1813 6.50622 12.2525C7.36619 8.77824 9.63653 5.68234 12.526 3.6528C13.2828 3.10241 13.9364 2.75842 14.8308 2.31124C16.6539 1.41686 18.6835 0.969677 20.7474 0.900879Z"
                                            fill="#007749" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M0.383789 39.9438C0.383789 41.3541 0.555782 41.8357 1.38136 42.9709C1.93174 43.7277 2.06935 43.762 2.72293 44.2436C3.6861 45.0004 4.33968 45.31 5.47484 45.8604C5.88763 46.0668 6.33481 46.2044 6.7476 46.3764C10.0843 47.7179 15.8977 48.6123 20.2664 48.6123C25.4951 48.6123 30.1733 48.3027 34.6796 46.7892C35.1612 46.6172 35.5395 46.5484 35.9523 46.3764C37.7067 45.654 40.149 44.5876 41.3186 43.0053C42.9009 40.9069 42.6945 38.8774 40.8714 36.9854C39.289 35.3343 37.5347 34.7151 35.6083 33.9583C34.9892 33.7175 32.9596 33.064 32.2372 33.064L25.9422 43.0053C25.7014 43.3493 25.5638 43.5557 25.3575 43.8996C23.9815 46.17 21.092 46.7548 18.8904 45.3788C18.3745 45.0348 17.7897 44.3812 17.4457 43.8652C17.2393 43.5557 17.1361 43.3149 16.8953 43.0053L10.5315 33.064C8.88034 33.0984 4.61487 34.8871 2.99811 36.0567C1.75975 36.9167 0.383789 38.4646 0.383789 39.9438Z"
                                            fill="#007749" />
                                    </svg>
                                    <span class="text">Г. АЛМАТЫ<br>ПРОСПЕКТ ДОСТЫК, 52</span>
                                </div>
                            </div>

                        </div>
                        <div class="map-container">
                            <img src="@/assets/img/map-img.png" alt="map" class="map-img">
                        </div>
                    </div>
                    <img src="@/assets/img/j-invicible.png" alt="j-invicible" class="j-invicible">

                </div>
            </div>
            <div class="main-container-third">
                <div class="second-box-content-container">
                    <div class="third-box">
                        <h4 class="big-title" style="max-width: 576px;">программа\ описание</h4>
                        <p class="title-third">Финал Jameson Distilled Sounds уже близко! Музыканты со всего Казахстана
                            прошли через отбор, чтобы оказаться на главной сцене конкурса.
                            В финале — 6 талантливых участников, которые поборются за главный приз: поездку в Ирландию
                            на музыкальные воркшопы и мастер-классы. Специальный гость вечера — именитый хэдлайнер.
                            Оставь свои контакты – узнаешь о хэдлайнере первым.</p>
                    </div>
                    <div>
                        <img src="@/assets/img/Jameson-bottle.png" alt="map" class="jameson-bottle">

                    </div>

                </div>
            </div>
            <div class="main-container-four">
                <div class="registration-body-container">
                    <div class="title-container">
                        <p class="text-title">Регистрация</p>
                    </div>
                    <div class="form-main">
                        <div class="form-container mt-4">
                            <p class="input-name">Имя Фамилия</p>
                            <input class="input-body" v-model="name" placeholder="Имя Фамилия" />
                        </div>
                        <div class="form-container mt-5">
                            <p class="input-name">Email</p>
                            <input class="input-body" v-model="email" placeholder="Email" />
                        </div>
                        <div class="form-container mt-5">
                            <p class="input-name">Телефон</p>
                            <input class="input-body" v-model="phone" @input="logNumber" v-mask="'+7(###) ###-##-##'"
                                placeholder="+7 (___) ___-__-__" />
                        </div>
                        <div class="form-container mt-5">
                            <p class="input-name">Город</p>
                            <v-select v-model="city" :items="items" dense outlined @input="logCity"
                                placeholder="Город"></v-select>
                        </div>

                        <div class="btn-container mt-4">
                            <div class="checkbox-container">
                                <input class="checkbox" type="checkbox" v-model="checkbox" name="checkbox" checked />
                                <label for="checkbox">Я даю согласие на <router-link to="#">сбор и обратботку с
                                        персональных
                                        данных</router-link></label>
                            </div>
                            <button @click="confirmRegistration" class="btn-green mt-10 mb-10">Получить
                                приглашение</button>
                        </div>
                    </div>

                </div>
            </div>
            <!-- <img src="@/assets/img/wave.png" alt=""> -->
            <div class="main-container-footer">

                <img src="@/assets/img/jameson-logo-age-confirm.png" alt="" class="jameson-logo-footer">
                <div class="footer-container">
                    <div class="politics-container">
                        <div class="footer-first-block">
                            <p class="link-text pb-5"> Ссылкой на этот ресурс запрещается делиться с лицами младше 21
                                года
                            </p>
                            <a class="link-text" style="text-decoration: underline;" href="">Ознакомься с нашей
                                политикой по ответствунному потреблению</a>
                        </div>
                        <div class="footer-second-block">
                            <p class="footer-main-text">Условия пользования</p>
                            <p class="footer-main-text">Полные правила активности</p>
                            <p class="footer-main-text">Политика конфиденциальности</p>
                        </div>
                    </div>
                    <div class="social-container">
                        <div class="" @click="goTo('https://www.facebook.com/')">
                            <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="25.8242" cy="25.8315" r="25" fill="#F2E4B5" />
                                <path
                                    d="M37.0742 18.1049C37.0742 16.2331 35.4227 14.5815 33.5509 14.5815H19.3475C17.4758 14.5815 15.8242 16.2331 15.8242 18.1049V32.3082C15.8242 34.18 17.4758 35.8315 19.3475 35.8315H26.5043V27.794H23.8618V24.2707H26.5043V22.8393C26.5043 20.417 28.2659 18.3251 30.468 18.3251H33.3307V21.8484H30.468C30.1377 21.8484 29.8074 22.1787 29.8074 22.8393V24.2707H33.3307V27.794H29.8074V35.8315H33.5509C35.4227 35.8315 37.0742 34.18 37.0742 32.3082V18.1049Z"
                                    fill="#154734" />
                            </svg>
                        </div>
                        <div @click="goTo('https://www.instagram.com/')">
                            <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="25.8242" cy="25.8315" r="25" fill="#F2E4B5" />
                                <path
                                    d="M36.3973 21.1698C36.3467 20.0215 36.161 19.232 35.895 18.548C35.6206 17.8218 35.1984 17.1717 34.6452 16.6313C34.1048 16.0825 33.4504 15.656 32.7327 15.3859C32.0447 15.1199 31.2593 14.9342 30.111 14.8835C28.9541 14.8286 28.5869 14.8159 25.6527 14.8159C22.7185 14.8159 22.3512 14.8286 21.1986 14.8792C20.0503 14.9299 19.2609 15.1157 18.5769 15.3816C17.8507 15.656 17.2006 16.0782 16.6601 16.6313C16.1113 17.1717 15.685 17.8261 15.4147 18.5439C15.1487 19.232 14.963 20.0172 14.9123 21.1655C14.8574 22.3224 14.8447 22.6897 14.8447 25.6239C14.8447 28.5581 14.8574 28.9253 14.9081 30.0779C14.9587 31.2263 15.1445 32.0157 15.4106 32.6998C15.685 33.4259 16.1113 34.076 16.6601 34.6164C17.2006 35.1653 17.8549 35.5918 18.5727 35.8619C19.2609 36.1279 20.046 36.3136 21.1945 36.3642C22.3469 36.415 22.7144 36.4276 25.6486 36.4276C28.5828 36.4276 28.95 36.415 30.1026 36.3642C31.2509 36.3136 32.0404 36.1279 32.7243 35.8619C34.1767 35.3003 35.325 34.152 35.8866 32.6998C36.1524 32.0116 36.3383 31.2263 36.3889 30.0779C36.4395 28.9253 36.4522 28.5581 36.4522 25.6239C36.4522 22.6897 36.4479 22.3224 36.3973 21.1698ZM34.4511 29.9935C34.4046 31.049 34.2273 31.6189 34.0796 31.9989C33.7164 32.9404 32.9692 33.6876 32.0277 34.0508C31.6477 34.1985 31.0736 34.3758 30.0223 34.4222C28.8824 34.473 28.5405 34.4855 25.657 34.4855C22.7734 34.4855 22.4272 34.473 21.2915 34.4222C20.236 34.3758 19.6661 34.1985 19.2861 34.0508C18.8176 33.8776 18.3911 33.6032 18.0449 33.2443C17.6861 32.8939 17.4116 32.4717 17.2385 32.0032C17.0907 31.6232 16.9134 31.049 16.8671 29.9978C16.8163 28.8579 16.8038 28.5159 16.8038 25.6323C16.8038 22.7487 16.8163 22.4026 16.8671 21.267C16.9134 20.2115 17.0907 19.6415 17.2385 19.2616C17.4116 18.7929 17.6861 18.3666 18.0492 18.0202C18.3995 17.6614 18.8217 17.387 19.2904 17.214C19.6703 17.0662 20.2446 16.8889 21.2958 16.8424C22.4357 16.7918 22.7777 16.7791 25.6611 16.7791C28.5489 16.7791 28.8908 16.7918 30.0266 16.8424C31.0821 16.8889 31.652 17.0662 32.032 17.214C32.5005 17.387 32.927 17.6614 33.2731 18.0202C33.632 18.3707 33.9064 18.7929 34.0796 19.2616C34.2273 19.6415 34.4046 20.2156 34.4511 21.267C34.5018 22.4069 34.5145 22.7487 34.5145 25.6323C34.5145 28.5159 34.5018 28.8536 34.4511 29.9935Z"
                                    fill="#154734" />
                                <path
                                    d="M25.6543 20.0715C22.5893 20.0715 20.1025 22.5581 20.1025 25.6233C20.1025 28.6884 22.5893 31.175 25.6543 31.175C28.7194 31.175 31.206 28.6884 31.206 25.6233C31.206 22.5581 28.7194 20.0715 25.6543 20.0715ZM25.6543 29.2246C23.6659 29.2246 22.053 27.6118 22.053 25.6233C22.053 23.6347 23.6659 22.022 25.6543 22.022C27.6428 22.022 29.2556 23.6347 29.2556 25.6233C29.2556 27.6118 27.6428 29.2246 25.6543 29.2246Z"
                                    fill="#154734" />
                                <path
                                    d="M32.7222 19.8522C32.7222 20.568 32.1419 21.1483 31.426 21.1483C30.7102 21.1483 30.1299 20.568 30.1299 19.8522C30.1299 19.1363 30.7102 18.5562 31.426 18.5562C32.1419 18.5562 32.7222 19.1363 32.7222 19.8522Z"
                                    fill="#154734" />
                            </svg>
                        </div>
                        <div @click="goTo('https://www.youtube.com/')">
                            <svg width="51" height="51" viewBox="0 0 51 51" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="25.8242" cy="25.8315" r="25" fill="#F2E4B5" />
                                <path
                                    d="M36.7156 24.4729C36.7156 23.9881 36.6348 23.4225 36.6348 22.776C36.554 22.1295 36.4732 21.4831 36.3924 20.9174C36.2308 20.2709 35.9884 19.7861 35.5035 19.3821C35.0995 18.978 34.5338 18.7356 33.9682 18.6548C32.1096 18.4123 29.3621 18.3315 25.6449 18.3315C21.9278 18.3315 19.0995 18.4123 17.3217 18.6548C16.756 18.7356 16.1904 18.978 15.7863 19.3821C15.3823 19.7861 15.0591 20.2709 14.8974 20.9174C14.7358 21.4831 14.655 22.0487 14.655 22.776C14.5742 23.4225 14.5742 23.9881 14.5742 24.4729C14.5742 24.9578 14.5742 25.5235 14.5742 26.3315C14.5742 27.1396 14.5742 27.7861 14.5742 28.1901C14.5742 28.675 14.655 29.2406 14.655 29.8871C14.7358 30.5336 14.8166 31.18 14.8974 31.7457C15.0591 32.3921 15.3015 32.877 15.7863 33.281C16.1904 33.6851 16.756 33.9275 17.3217 34.0083C19.1803 34.2507 21.9278 34.3315 25.6449 34.3315C29.3621 34.3315 32.1904 34.2507 33.9682 34.0083C34.5338 33.9275 35.0995 33.6851 35.5035 33.281C35.9075 32.877 36.2308 32.3921 36.3924 31.7457C36.554 31.18 36.6348 30.6144 36.6348 29.8871C36.7156 29.2406 36.7156 28.675 36.7156 28.1901C36.7156 27.7053 36.7156 27.1396 36.7156 26.3315C36.7156 25.5235 36.7156 24.877 36.7156 24.4729ZM29.9278 26.978L23.5439 30.9376C23.4631 31.0184 23.3015 31.0992 23.1399 31.0992C22.9783 31.0992 22.8975 31.0992 22.7358 31.0184C22.4934 30.8568 22.3318 30.6144 22.3318 30.2911V22.2911C22.3318 21.9679 22.4934 21.7255 22.7358 21.5639C22.9783 21.4023 23.3015 21.4023 23.5439 21.5639L29.9278 25.5235C30.1702 25.6851 30.3318 25.9275 30.3318 26.1699C30.3318 26.4123 30.1702 26.8164 29.9278 26.978Z"
                                    fill="#154734" />
                            </svg>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped>
.first-wave {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;


}

.j-invicible {
    position: absolute;
    top: clamp(40px, 7vh, 70px);
    /* минимально 40px, адаптивно по высоте экрана, максимально 70px */
    right: 0;
    z-index: 0;
    width: clamp(200px, 23.2vw, 446px);
    height: clamp(300px, 61.8vh, 667px);
}

.social-container {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin-top: auto;
    cursor: pointer;
    /* 💡 прижмет вниз */
}

.social-container svg {
    width: 48px;
    height: 48px;
    transition: transform 0.3s ease;
}

.social-container svg:hover {
    transform: scale(1.1);
}

.footer-first-block {
    max-width: clamp(240px, 21.04vw, 404px);
    margin-right: clamp(20px, 3.13vw, 60px);
}

.politics-container {
    display: flex;
}

.footer-container {
    padding-top: clamp(40px, 6.36vh, 68.68px);
    display: flex;
    justify-content: space-between;
}

.link-text {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: 16px;
    color: #f2e4b5;
    margin-bottom: 0px;
}

.footer-main-text {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: clamp(14px, 1.5vw, 20px);
    line-height: 175%;
    color: #f2e4b5;
    margin-bottom: 0;
}

.jameson-logo-footer {
    width: clamp(150px, 13.95vw, 268px);
    /* 268px ≈ 13.95vw на экране 1920px */
    height: clamp(36px, 5.93vh, 64px);
    /* 64px ≈ 5.93vh на экране 1080px */
}

.form-container {
    display: flex;
    align-items: baseline;
    /* Центрирование по вертикали */
    justify-content: flex-end;
    /* Разделение текста и поля ввода */
    width: 100%;
    /* Растягиваем контейнер */
}

.input-body::placeholder {
    color: #5A5A5A;
    /* Задайте нужный цвет */
    font-size: 24px;
    /* При необходимости измените размер шрифта */
    ;
    /* Добавьте стиль, например, курсив */
    opacity: 1;
    /* Убедитесь, что текст полностью видим */
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 4px 25px;
}

::v-deep .v-select input::placeholder {
    color: #5A5A5A !important;
    font-weight: 400;
    font-size: 24px;


}

::v-deep .v-list-item--dense .v-list-item__title {
    font-size: 24 !important;

}


.btn-green {
    border-radius: 10px;
    padding: 11px 42px;
    width: 320px;
    height: 59px;
    background: #007749;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 20px;
    color: #f2e4b5;
}

.btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.checkbox-container {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
}

.checkbox {
    /* appearance: none; */
    /* убираем стандартный стиль браузера */
    width: 20px;
    height: 20px;
    border: 1px solid #007749;
    background-color: white;
    margin-right: 6px;
}

/* .checkbox:checked {
    background-color: #007749;
    border-color: #007749;
} */

input:focus {
    outline: 1px solid #1976d2;
    /* синяя обводка */
    /* или */
    box-shadow: 0 0 5px #1976d2;
}

::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: #007749 !important;
    border-radius: 6.64px;
}

::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 0;
    font-size: 24px;
}

::v-deep .v-input__slot {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition-property: height, min-height;
    width: 461px;
}

::v-deep .v-input {
    align-items: flex-start;
    display: flex;
    flex: none;
    font-size: 16px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;

}

.form-main {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    /* text-align: left; */
    /* margin: auto; */
    width: 100%;
    max-width: 667px;
    margin-left: 159px;
    margin-right: 210px;
}

.input-body {
    border: 1px solid #007749;
    border-radius: 10px;
    padding: 15px 30px;
    width: 461px;
    height: 50px;
    font-size: 24px;
    /* margin-left: auto; */
    /* Выравнивание поля ввода вправо */
}

.input-name {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: 24px;
    color: #154734;
    margin-right: 20px;
    margin-bottom: 0px;
    /* Отступ между текстом и полем ввода */
    white-space: nowrap;
    /* Предотвращаем перенос текста */
}

.text-title {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 48px;
    text-transform: uppercase;
    text-align: center;
    color: #154734;
    margin-bottom: 0;
    text-transform: uppercase;
    line-height: 1.2;
}

.title-container {
    width: 798px;
    margin: auto;
    padding-top: 3.48vh;
}

.registration-body-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    /* width: 53.85vw; */
    max-width: 1033px;
    min-width: 320px;
    height: 100%;
    /* max-height: 713px; */
    /* min-height: 400px; */
    background: #f2e4b5;
    margin: auto;
}

.third-box {
    width: clamp(320px, 50vw, 885px);

}

.second-box-content-container {
    display: flex;
    padding-top: clamp(30px, 10vh, 101px);
    align-items: center;
    justify-content: space-between;
    /* от 30px до 101px, в зависимости от высоты экрана */
}

.title-third {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: clamp(20px, 2.2vw, 32px);
    /* адаптивный размер */
    color: #fff;
    margin-bottom: 0px;
}

.jameson-bottle {
    border-radius: 20px;
    width: clamp(280px, 31.25vw, 600px);
    height: clamp(350px, 39.06vw, 750px);
}

.box-content-container {
    display: flex;
    justify-content: space-between;
    margin-top: clamp(20px, 3.5vw, 68px);
    z-index: 100;
    position: relative;
}

.map-img {
    width: clamp(300px, 58vw, 1111px);
    height: clamp(160px, 28vw, 540px);
    max-width: 100%;
    object-fit: cover;
    /* если нужно красиво обрезать/вписывать */
    display: block;
}

.box-container {
    display: flex;
    flex-direction: column;
    gap: clamp(24px, 4.5vw, 86px);
    /* адаптивный gap */
}

.outer-box {
    width: clamp(280px, 19.6vw, 376px);
    /* адаптивная ширина */
    height: clamp(85px, 6vw, 117px);
    /* адаптивная высота */
    padding: clamp(3px, 0.5vw, 5px);
    /* адаптивный отступ */
    border-radius: clamp(8px, 1vw, 12px);
    box-sizing: border-box;
    border: 2px solid #007749;
}

.info-box {
    width: 100%;
    height: 100%;
    border: 2px solid #007749;
    border-radius: clamp(6px, 0.8vw, 8px);
    display: flex;
    align-items: center;
    padding: clamp(16px, 2vw, 30px) clamp(12px, 1.8vw, 24px);
    /* адаптивный padding */
    gap: clamp(10px, 1.5vw, 20px);
    /* адаптивный gap между иконкой и текстом */
    background-color: transparent;
    box-sizing: border-box;
    justify-content: center;
}

.text {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: clamp(14px, 1.5vw, 20px);
    /* адаптивный размер шрифта */
    text-transform: uppercase;
    color: #007749;
    line-height: 130%;
}

.h4-title {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: clamp(24px, 2.08vw, 40px);
    text-transform: uppercase;
    color: #154734;
    text-align: center;
    padding-top: clamp(16px, 2.5vw, 46px);
}

.main-content-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.j-img {
    width: 28.65vw;
    height: auto;
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
}

.block-one {
    max-width: 911px;
    width: 100%;
}

.big-title {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: clamp(36px, 6vw, 79px);
    /* от 36px до 79px */
    text-transform: uppercase;
    color: #f1e4b2;
}

.title-top {
    font-family: var(--font-family);
    font-weight: 700;
    font-size: clamp(18px, 2vw, 32px);
    /* от 18px до 32px */
    line-height: 150%;
    text-transform: uppercase;
    color: #fff;
}

.first-block {
    /* padding-top: clamp(40px, 9.07vh, 98px); */
    padding-top: 98px;
}

.jameson-logo-age-confirm {
    width: clamp(150px, 18.39vw, 353px);
    height: clamp(36px, 4.375vw, 84px);
}

.main-container-first {
    padding-left: clamp(16px, 10vw, 195.74px);
    padding-right: clamp(16px, 9.5vw, 184.11px);
}

.main-container-second[data-v-9bae1d64] {
    padding-left: clamp(16px, 10vw, 195.74px);
    padding-right: clamp(16px, 9.5vw, 184.11px);
    padding-bottom: clamp(40px, 7.5vh, 81px);
    background-color: #f2e4b5;
    position: relative;
    z-index: 100;
}

.main-container-third {
    padding-left: clamp(16px, 10vw, 195.74px);
    padding-right: clamp(16px, 9.5vw, 184.11px);
    padding-bottom: clamp(40px, 7.5vh, 101px);
    background-image: url('~@/assets/img/third-container-bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.main-container-four {
    padding-left: clamp(16px, 10vw, 195.74px);
    padding-right: clamp(16px, 9.5vw, 184.11px);
    padding-top: clamp(40px, 6.76vh, 73px);
    padding-bottom: clamp(40px, 7.5vh, 101px);
    background-image: url('~@/assets/img/four-container-bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.main-container-footer {
    padding-left: clamp(16px, 10vw, 195.74px);
    padding-right: clamp(16px, 9.5vw, 184.11px);
    padding-top: clamp(40px, 6.76vh, 73px);
    padding-bottom: clamp(40px, 7.5vh, 101px);
    background-color: #154734;

}
</style>

<script>
import { mask } from "vue-the-mask";
export default {


    name: "RegisterForEvent",
    directives: { mask },
    data() {
        return {
            day: "",
            month: "",
            year: "",
            message: "",
            phone: '',
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
            checkbox: false,
            email: '',
            name: '',
            city: '',
            showPopup: false,
            snackbar: false,

        };
    },
    methods: {
        goTo(url) {
            window.open(url, '_blank'); // Откроется в новой вкладке
        },
        logCity() {
            console.log(this.city);
        },
        logNumber() {
            console.log(this.phone);
        },
        confirmRegistration() {
            // Проверка на заполненность всех полей
            if (this.name && this.email && this.phone && this.city && this.checkbox) {
                console.log('Регистрация подтверждена:');
                this.showPopup = true; // Открыть pop-up
            } else {
                // alert(''); // Сообщение об ошибке
                this.snackbar = true;
                this.message = 'Пожалуйста, заполните все поля и подтвердите согласие';
            }
        },


    },
    computed: {
        // Вычисляемое свойство для стиля фона
        bgStyle() {
            return {
                backgroundImage: `url(${require('@/assets/img/registration-main-bg.png')})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                minHeight: '100vh',
                position: 'relative', // ← здесь ключ camelCase, значение в кавычках
                zIndex: 1,
            };
        }
    }
}
</script>